<app-side-menu></app-side-menu>
<!-- <router-outlet></router-outlet>  -->

  <app-host-watcher
    [show]="showModal"
    [title]="modalTitle"
    [message]="modalMessage"
    [status]="modalStatus"
    [networkDetails]="networkDetails"
    (closeModal)="closeModal()"
    (retryCheck)="checkHostWatcher()">
  </app-host-watcher>
